import React, { useEffect, useState } from 'react';
import { classnames } from '../../utils/text';
import { isArray } from 'lodash';
import DataComponent from '../DataComponent';
import { isEmpty } from '../../utils/lodashExtend';
import { autoHyphen } from '../../utils/replace';

const Quotation = ({ type, onChange, form, errors, formType }) => {
  const [fields, setFields] = useState([]);
  const [tableFields, setTableFields] = useState([]);
  useEffect(() => {
    setFields([
      [
        {
          title: `수신`,
          key: `byrCorpName`,
          type: "input",
          className: "font-size-13 text-align-right",
          options: {
            placeholder: formType === "detail" ? " " : "수신 입력",
            disabled: formType === "detail",
          },
        }
      ],
      [
        {
          title: "제목",
          key: `title`,
          type: "input",
          placeholder: "제목 입력",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "제목 입력",
            disabled: formType === "detail",
            bodyClassName: "w-full",
          },
        }
      ],
      [
        {
          title: "내용",
          key: `content`,
          type: "input",
          options: {
            placeholder: formType === "detail" ? " " : "내용 입력",
            disabled: formType === "detail",
            bodyClassName: "w-full",
          },
        }
      ],
      [
        {
          title: "작성일자",
          key: `writeDate`,
          type: "datepicker",
          className: "write-date",
          labelClassName: "font-size-13",
          disabled: formType === "detail",
        },

      ],
      [
        {
          title: "유효일",
          key: `effectiveDateLength`,
          type: "number",
          className: "effective-date text-align-right",
          labelClassName: "font-size-13",
          style: {
            width: "100px"
          },
          options: {
            placeholder: " ",
            disabled: formType === "detail",
          },
        },
      ]
    ]);

    setTableFields([
      [
        {
          title: "상호",
          key: `supCorpName`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "상호 입력",
            disabled: formType === "detail",
          },
        }
      ],
      [
        {
          title: "등록번호",
          key: `supBizNo`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "등록번호 입력",
            disabled: formType === "detail",
          },
          onValue: (value) => {
            return !isEmpty(value) && autoHyphen("comNum", value);
          }
        }
      ],
      [
        {
          title: "주소",
          key: `supAddress`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "주소 입력",
            disabled: formType === "detail",
          },
        }],
      /*  [
         {
           title: "전화",
           key: `supMobile`,
           type: "input",
           className: "font-size-13",
           options: {
             placeholder: formType === "detail" ? " " : "전화 입력",
             disabled: formType === "detail",
           },
         }
       ], */
      [
        {
          title: "E-MAIL",
          key: `supEmail`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "E-MAIL 입력",
            disabled: formType === "detail",
          },
        }
      ],
      [
        {
          title: "대표",
          key: `supRepName`,
          type: "input",
          className: "font-size-13",
          options: {
            placeholder: formType === "detail" ? " " : "대표명 입력",
            disabled: formType === "detail",
          },
        }
      ]
    ]);
  }, [type, formType]);

  return (
    <>
      <div className={classnames(`${type}-form`)}>
        {!isEmpty(fields) && fields.map((_fields, key) => {
          return (
            <React.Fragment key={key}>
              <div className='fields-wrap'>
                {isArray(_fields) && _fields.map((field, _key) => {
                  return (
                    <div key={_key} className="field-wrap">
                      <div className='title-wrap'>
                        <span>{field.title}</span>
                      </div>
                      {field.key === "effectiveDateLength" && (
                        <div className='before-wrap'>
                          <span style={{ fontSize: "13px" }}>작성일로부터</span>
                        </div>
                      )}
                      <div className={`body-wrap ${field?.options?.bodyClassName || ""}`}>
                        <DataComponent
                          form={form}
                          field={field}
                          onChange={onChange}
                        />
                      </div>
                      {field.key === "byrCorpName" && (
                        <div className='after-wrap'>
                          <span>귀하</span>
                        </div>
                      )}
                      {field.key === "effectiveDateLength" && (
                        <div className='after-wrap'>
                          <span style={{ fontSize: "13px" }}>일</span>
                        </div>
                      )}
                      {field.key === "estimatedAmt" && (
                        <div className='after-wrap'>
                          <span>원</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          );
        })}


      </div >
      <div className={classnames(`${type}-form table-fields`)}>

        <table className="form-wrap">
          <tbody>
            {isArray(tableFields) &&
              tableFields.map((_fields, index) => (
                <tr key={index} className={classnames("form-row", type, _fields[0].id)}>
                  {isArray(_fields) &&
                    _fields.map((field, idx) => (
                      <React.Fragment key={idx}>
                        <td className={classnames("form-title-wrap", type)}>
                          {field.required && (
                            <span className="required-option">*</span>
                          )}
                          <span>{field.title}</span>
                        </td>
                        <td
                          className="form-input-wrap"
                          colSpan={_fields.length === 1 ? 3 : 1}
                        >
                          <DataComponent
                            form={form}
                            field={field}
                            onChange={onChange}
                          />
                          {errors && errors[field.key] && (
                            <div className="message">
                              <p className="error-message">{errors[field.key]}</p>
                            </div>
                          )}
                        </td>
                      </React.Fragment>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Quotation;